<template>
  <div class="dropdown">
    <a-dropdown>
      <a class="name"  @click.prevent>{{merchantName}}
        <img class="arrows" width="24px"  src="../../assets/images/downOut.png" v-if="merchantOptions.length > 1"/>
      </a>
      <a-menu slot="overlay">
        <a-menu-item v-for="item in merchantOptions" :key="item.customerId" :value="item.customerId">
          <div @click="switchTenant(item)">{{item.tenantName}}</div>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>
<script>
import { post } from '@/utils/http';
import api from '@/api';
import { message } from 'ant-design-vue';
import {
  setAccount, setToken,
} from '../../views/login/login-handler';
import { getUiFitment } from '@/utils/accessResources';
import mainBus from '@/micro/eventBus';

export default {
  name: 'TenantSwitch',
  created() {
    this.getTenantList();
  },
  data() {
    return {
      merchantName: '',
      merchantOptions: [],
    };
  },
  mounted() {
    mainBus.$on('systemInterface', () => {
      // eslint-disable-next-line no-unused-expressions
      // this.switchTenant()
      this.merchantOptions.forEach(m => {
        if(m.tenantName === this.merchantName) {
          this.switchTenant(m)
        }
      });
    });
  },
  methods: {
    getTenantList() {
      const appId = localStorage.getItem('appId') || '';
      const userInfo = localStorage.getItem('user_info') || '{}';
      const info = JSON.parse(userInfo);
      this.merchantName = info.tenantName;
      post(api.tenantList, { appId, userId: info.passportId }).then((res) => {
        this.merchantOptions = res;
      });
    },
    switchTenant(val) {
      post(api.switchTenant, { customerId: val.customerId }).then((res) => {
        setToken(res);
        this.getLoginAccount(res);
      });
    },
    // 获取用户信息
    getLoginAccount  (loginRes)  {
      post(api.loginAccount, {}).catch(() => {
        message.error('用户信息查询失败');
      })
        .then((res) => {
          // 之后缓存菜单需要参数
           setAccount(res, loginRes);
           getUiFitment().finally(()=>{
                if (res.id) {
                this.$store.commit('emptyTab');
                this.$router.push('/');
                // eslint-disable-next-line no-restricted-globals
                location.reload();
              }
           })
        });
    },
  },
};
</script>

<style lang="less" scoped>

.dropdown{
  padding-left: 16px;
  .name{
    font-size: 14px;
    padding-bottom: 8px;
    color: #666666;
  }
  .arrows{
    left: 8px;
    padding-bottom: 5px;
  }
}
</style>
